/*
 * Ted "Tap to talk" button (02-10-2026).
 * Customers didn't notice the small mic icon in the product-page box and the homepage hero, so this turns
 * that mic into a big labelled button at the top of the ask area. It stays a .ted-mic button, so
 * assets/ted.js still runs it (start/stop listening, is-rec / is-busy states) with no other changes.
 * Loaded after ted.js by snippets/ted.liquid. Styles: assets/ted-talk.css.
 */
(function () {
  'use strict';
  var COPY = {
    pdp: { main: 'Tap to talk to Ted', hint: 'Just ask out loud. Ted answers you back.' },
    home: { main: 'Tap to talk to Ted', hint: "Just say what you're covering. Ted answers out loud." }
  };
  function upgrade() {
    [].forEach.call(document.querySelectorAll('.ted-e [data-ted-pdp]'), function (form) {
      var mic = form.querySelector('.ted-mic');
      if (!mic || mic.classList.contains('ted-talk')) return;
      var box = form.closest('.ted-e'), c = box.hasAttribute('data-ted-home') ? COPY.home : COPY.pdp;
      var svg = mic.innerHTML;
      mic.classList.add('ted-talk');
      mic.removeAttribute('title');
      mic.innerHTML = '<span class="ted-talk__ic">' + svg + '</span><span class="ted-talk__txt">' +
        '<span class="ted-talk__idle"><b class="ted-talk__main">' + c.main + '</b><span class="ted-talk__hint">' + c.hint + '</span></span>' +
        '<span class="ted-talk__rec"><b class="ted-talk__main">Listening… speak now</b><span class="ted-talk__hint">Ted sends it when you pause. Tap to stop.</span></span>' +
        '<span class="ted-talk__busy"><b class="ted-talk__main">Got it, one moment…</b><span class="ted-talk__hint">Ted is working out your answer</span></span>' +
        '</span>';
      form.classList.add('has-talk');
      var sub = box.querySelector('.ted-e__sub');
      if (sub && box.classList.contains('ted-e--pdp')) sub.textContent = 'Talk or type to Ted, our AI cover specialist. Answers in seconds, with the right size and price for your job.';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upgrade); else upgrade();
  // ted.js mounts the product box on load; catch it if it lands after this script.
  window.addEventListener('load', upgrade);
})();
